import { hasActiveObservations as t } from "./highrise1842.mjs";
import { hasSkippedObservations as e } from "./highrise1843.mjs";
import { deliverResizeLoopError as i } from "./highrise1844.mjs";
import { broadcastActiveObservations as s } from "./highrise1845.mjs";
import { gatherActiveObservationsAtDepth as o } from "./highrise1846.mjs";
var n = function() {
  var r = 0;
  for (o(r); t(); )
    r = s(), o(r);
  return e() && i(), r > 0;
};
export {
  n as process
};
